<template>
  <div>
    <v-overlay :value="$store.state.overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="mobileview pt-8 text_color">
      {{ $t("newUi.adminViewform.addCat") }}
    </div>
    <v-container class="padding_view desktop_section">
      <v-text-field
        v-bind:label="$t('newUi.addCategory.name')"
        v-model="name"
        v-bind:title="$t('')"
        autocomplete="off"
        required
      ></v-text-field>
      <div class="mobile_data desktop_section_button">
        <v-btn
          @click="add_category_submit(name)"
          class="button_padding"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.save") }}
        </v-btn>
        <v-btn
          @click.prevent="cancel"
          class="button_padding desktopView"
          color="#8AB26D"
        >
          {{ $t("newUi.editForm.cancel") }}
        </v-btn>
        <div class="text-decoration-underline cursor-pointer text_color mt-2">
          <span @click="add_category_more(name)">
            {{ $t("newUi.addItem.saveMore") }}</span
          >
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import router from "../router/router";
import { saveFile, setLocale,loadFile} from "../services/firebase";
import { saveMasterData } from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
export default {
  props: ["payload"],

  data() {
    return {
      sheet: false,
      add_category: false,
      name: "",
      description: "",
      addproduct_category: "",
      addproduct_desc: "",
      addproduct_name: "",
      addproduct_price: 0,
      addproduct_image: "",
      cropped: null,
      cropDialog: false,
      croppieElm: null,
    };
  },
  mounted() {
    setLocale();
    this.set_category_item_null();
  },
  computed: {
    type: function() {
      if (this.payload.type == "Ordering form") {
        return i18n.t("common.typeOrderForm");
      } else {
        return i18n.t("common.typeCatelogue");
      }
    },
    category_name: function() {
      let categories = [];
      let objects = this.payload.catalogue.filter((o) => o.type == "category");
      objects.forEach((item) => {
        categories.push(item.name);
      });
      return categories;
    },
    isEditable: function() {
      if (this.$route.name === "viewform") return false;
      return true;
    },
  },
  methods: {
    fetchData: function() {
      var store = this.$store;
      store.dispatch("setOverlay", true);
      store.dispatch("setCurrentFormData", {
        id: store.state.profile.uid,
        pos: "",
        categs: ["Ordering form", "Catalogue"],
        shopname: "",
        shopdesc: "",
        type: "",
        catalogue: [],
        phone: "",
      });
      this.$store.state.currentFormPos = this.$route.params.formno;
      const disele = this;

      loadFile(
        disele.$store.state.profile.uid,
        disele.$route.params.formno,
        disele.$store.state,
        function(error) {
          if (error) {
            //TODO skeleton data
            store.dispatch("setCurrentFormData", {
              id: store.state.profile.uid,
              pos: store.state.currentFormPos,
              categs: ["Ordering form", "Catalogue"],
              shopname: "",
              shopdesc: "",
              type: "Ordering form",
              catalogue: [],
              phone: "+919000000000",
            });
            store.dispatch("fileLoaded", true);
            disele.linkval;
            store.dispatch("setOverlay", false);
          } else {
            store.dispatch("fileLoaded", true);
            disele.linkval;
            store.dispatch("setOverlay", false);
          }
        }
      );
    },
    add_catag: function(name) {
      var p = this.$store.state.currentForm.maxlength;
      if (!p) {
        for (var i = 0; i < this.$store.state.forms.length; i++) {
          let form = this.$store.state.forms[i];
          if (form.link.split("/")[3] == this.$store.state.currentForm.pos) {
            this.$store.state.forms[i].image =
              "https://firebasestorage.googleapis.com/v0/b/gupshup-gipforms.appspot.com/o/files%2Flogo.png?alt=media&token=56547b3f-f39c-48cf-840f-e4bc085422a5";
          }
        }
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "category",
        name: name,
      });
    },
    set_category_item_null() {
      this.name = "";
    },
    submit: function() {
      this.sheet = true;
    },
    add_category_open: function() {
      this.add_category = true;
    },
    add_category_submit: function(name) {
      var exists = false;
      if (name == null || !name || name == "") {
        alert(i18n.t("alertText.nameAlert"));
      } else if (name.length > 25) {
        alert(i18n.t("alertText.catFormMax"));
      } else {
        this.$store.state.currentForm.catalogue.map((each_category) => {
          if (each_category.type == "category") {
            if (
              each_category.name.toLowerCase().replace(/ /g, "") ===
              name.toLowerCase().replace(/ /g, "")
            ) {
              exists = true;
            }
          }
        });
        if (exists) alert(i18n.t("alertText.CategoryExists"));
        else {
          this.add_category = false;
          this.add_catag(name);
          this.saveCurrentForm();
          this.$emit("open_add_category_modal");
         /* if (
            router.currentRoute.fullPath ==
              "/admin/editform/" + this.$store.state.currentForm.pos ||
            router.currentRoute.fullPath ==
              "/admin/additemstoform/" + this.$store.state.currentForm.pos
          ) {
            this.add_catag(name);
            this.saveCurrentForm();
          } else {
            console.log('else')
            this.add_catag(name);
            this.saveCurrentFormMore();
          }*/
        }
      }
    },
    cancel: function() {
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    add_category_more: function(name) {
      var exists = false;
      if (name == null || !name || name == "") {
        alert(i18n.t("alertText.nameAlert"));
      } else if (name.length > 25) {
        alert(i18n.t("alertText.catFormMax"));
      } else {
        this.$store.state.currentForm.catalogue.map((each_category) => {
          if (each_category.type == "category") {
            if (
              each_category.name.toLowerCase().replace(/ /g, "") ===
              name.toLowerCase().replace(/ /g, "")
            ) {
              exists = true;
            }
          }
        });
        if (exists) alert(i18n.t("alertText.CategoryExists"));
        else {
          this.add_catag(name);
          this.saveCurrentFormMore();
          this.set_category_item_null();
          this.add_category = true;
        }
      }
    },
    saveCurrentForm: function() {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        var elethis = this;
        console.log('this.$store.state.currentForm',this.$store.state.currentForm);
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
            }
            else{
              store.dispatch("setOverlay", false);
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          console.log('location',window.location.pathname);
          this.name="";
          if(window.location.pathname=="/admin/viewform/" +this.$store.state.currentForm.pos)
          {
              this.fetchData();
          }
          else{
            router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
          }
          
        });
      }
    },
    saveCurrentFormMore: function() {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;

      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone.length == 0) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        var elethis = this;
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
              // elethis.set_overlay = false;
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          store.dispatch("setOverlay", false);
        });
        this.name="";
      }
    },
  },
};
</script>
<style lang="scss">
.button_padding {
  margin-right: 10px;
  padding: 10px;
  font-weight: bold;
  color: white !important;
  text-align: center;
  letter-spacing: 0px;
  text-transform: none;
  cursor: pointer;
}
.bottom_modal {
  border-top-right-radius: 20px !important;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
@media (min-width: 960px) {
  .desktop_section {
    margin-top: 120px;
  }
  .desktop_section_button {
    margin-top: 100px;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .mobile_data {
    text-align: center;
  }
  .desktop_section_button {
    margin-top: 30px;
    margin-bottom: 10px;
  }
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
</style>
